import { Enums } from '../models/common/enums'

import { OpDashboardControl } from '../models/custom/op-dashboard-control'
import { OpCardControl } from '../models/custom/op-card-control'
import { OpChartControl } from '../models/custom/op-chart-control'
import { OpGaugeControl } from '../models/custom/op-gauge-control'
import { OpGridControl } from '../models/custom/op-grid-control'
import { OpMapControl } from '../models/custom/op-map-control'
import { OpSchemaControl } from '../models/custom/op-schema-control'
import { OpTileControl } from '../models/custom/op-tile-control'

export class DashboardComponent {
    public static CreateDashboardControl(dashboardControls: any[]): OpDashboardControl[] {
        if (!dashboardControls && dashboardControls.length > 0 && dashboardControls[0].Class != undefined)
            return []
        return dashboardControls.map(c => {
            if (c.Class == Enums.DashboardItemClass.TILE)
                return new OpTileControl(c)
            else if (c.Class == Enums.DashboardItemClass.CARD)
                return new OpCardControl(c)
            else if (c.Class == Enums.DashboardItemClass.CHART)
                return new OpChartControl(c)
            else if (c.Class == Enums.DashboardItemClass.GAUGE)
                return new OpGaugeControl(c)
            else if (c.Class == Enums.DashboardItemClass.GRID)
                return new OpGridControl(c)
            else if (c.Class == Enums.DashboardItemClass.MAP)
                return new OpMapControl(c)
            else if (c.Class == Enums.DashboardItemClass.SCHEMA)
                return new OpSchemaControl(c)
            else
                return new OpDashboardControl(c)
        })
    }
}